import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiEye, FiEyeOff, FiShield, FiLock, FiMail } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const SuperAdminLogin = () => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(credentials, 'superadmin');

    if (result.success) {
      toast.success('Super Admin login successful!');
      navigate('/superadmin/dashboard');
    } else {
      toast.error(result.message || 'Login failed');
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        {/* Header - Matching the regular login theme */}
        <div className="bg-gradient-to-r from-[#2596be] to-[#1e7a9e] p-8 text-center">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <FiShield className="text-white text-2xl" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">HUKAM MERE AAKA</h1>
          <p className="text-blue-100 text-sm">Super Admin Portal</p>
        </div>

        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          {/* Email Field */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              <FiMail className="inline mr-2" size={16} />
              Email Address
            </label>
            <input
              type="email"
              name="email"
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#2596be] focus:ring-2 focus:ring-[#2596be] focus:ring-opacity-20 transition-all outline-none"
              placeholder="Enter super admin email"
              value={credentials.email}
              onChange={handleChange}
              required
            />
          </div>

          {/* Password Field */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              <FiLock className="inline mr-2" size={16} />
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="w-full px-4 py-3 pr-12 border-2 border-gray-200 rounded-lg focus:border-[#2596be] focus:ring-2 focus:ring-[#2596be] focus:ring-opacity-20 transition-all outline-none"
                placeholder="Enter password"
                value={credentials.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-[#2596be] transition-colors p-1"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
              </button>
            </div>
          </div>

          {/* Submit Button - Matching the regular login theme */}
          <button 
            type="submit" 
            className="w-full bg-gradient-to-r from-[#2596be] to-[#1e7a9e] text-white font-semibold py-3 rounded-lg hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Logging in...
              </span>
            ) : (
              <div className="flex items-center justify-center gap-2">
                <FiShield size={20} />
                <span>Login as Super Admin</span>
              </div>
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="px-8 pb-8 text-center">
          <p className="text-sm text-gray-600">
            <Link to="/login" className="text-[#2596be] font-semibold hover:underline">
              ← Back to regular login
            </Link>
          </p>
        </div>

        
      </div>
    </div>
  );
};

export default SuperAdminLogin;
